import {
	type FrontendPlacementMessage,
	type FrontendStage,
} from '@post-office/message-maker-browser/types';

import { prefetchAll } from '@atlassian/switcher/prefetch';

import { noValidation } from '@post-office/message-maker-browser/message-helpers';

import { ManualMessageViewedEvent } from '@post-office/placement-contexts/message-viewed-component';

import {
	PlacementFrontend,
	type PlacementRenderProps,
} from '@post-office/browser--townsquare/townsquare-screen-space-flags';

import { useEffect } from 'react';

import { Onboarding } from '../../../components/Onboarding';

import { type MessageTemplateContext } from '../../../index';

import { SpotlightTourMode } from '../../../components/types';

import type { CreatePlacementMessageConfig } from '@post-office/message-template-contracts/placement-v2';

type RenderProps = MessageTemplateContext & PlacementRenderProps;

export const render: {
	type: 'render';
	validate: (input: unknown) => RenderProps;
	Component: (
		input: PlacementRenderProps & {
			variant: 'twc' | 'loom' | 'var3' | 'var4' | 'var5' | 'var6' | 'none';
			appOneName?: string;
			appTwoName?: string;
			spotlightTourMode: SpotlightTourMode;
		},
	) => JSX.Element | null;
} = PlacementFrontend.createFrontendStage({
	type: 'render',
	validate: noValidation<RenderProps>(),
	Component: ({
		openRovoPanel,
		toggleSidebar,
		toggleSwitcher,
		dismiss,
		userName,
		isRovoChatOpen,
		variant,
		spotlightTourMode,
		appOneName,
		appTwoName,
		cloudId,
	}) => {
		// this ensures switcher is preloaded when the spotlight tour highlights it
		useEffect(() => {
			if (spotlightTourMode !== SpotlightTourMode.DISABLED && typeof window !== 'undefined') {
				prefetchAll({ cloudId: cloudId ?? undefined, product: 'townsquare' });
			}
			// eslint-disable-next-line react-hooks/exhaustive-deps
		}, []);

		if (variant === 'none') {
			return null;
		}

		return (
			<ManualMessageViewedEvent>
				<Onboarding
					userName={userName}
					openRovoPanel={openRovoPanel}
					isRovoChatOpen={isRovoChatOpen}
					toggleSidebar={toggleSidebar}
					toggleSwitcher={toggleSwitcher}
					dismiss={dismiss}
					variant={variant}
					appOneName={appOneName}
					appTwoName={appTwoName}
					spotlightTourMode={spotlightTourMode}
				/>
			</ManualMessageViewedEvent>
		);
	},
});

export const MessageFrontend: (config: CreatePlacementMessageConfig) => FrontendPlacementMessage<{
	render: FrontendStage<PlacementRenderProps>;
}> = PlacementFrontend.createMessageFrontend({
	render,
});
